import { Typography, List, ListItem, ListItemText } from "@mui/material";
import TextBlock from "../typeComponents/TextBlock";
import Paragraph from "../typeComponents/Paragraph";
import MainHeading from "../typeComponents/MainHeading";
const OurMandate = () => {
  return (
    <TextBlock>
      <MainHeading>Our Mandate</MainHeading>
      {/* a custom Typography because we want this short line to always hang left */}
      <Typography variant="body1" gutterBottom sx={{ alignSelf: "flex-start" }}>
        The work of CURE is rooted in an anti-oppression analysis and a
        community-driven social justice research model that seeks to:
      </Typography>
      {/* the default component of List is "ul", which is fine here */}
      <List>
        <ListItem>
          <ListItemText primary="Give community organizations, specifically those experiencing social and economic marginalization, access to the knowledge and resources circulating in the academic sphere;" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Facilitate productive, mutually transformative interactions between students and activists that redefine the boundary between universities and the communities that surround them;" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Broaden the kind of academic work that is available to students;" />
        </ListItem>
      </List>
      <Paragraph>
        CURE strives to avoid the pitfalls associated with academic research,
        specifically with academic research that objectifies community
        organizing and activism. Co-optation of grassroots knowledge and
        movements by the academic sphere is a widespread occurrence and CURE
        aims to avoid this by taking direction from community organizations to
        define and have autonomy over their research needs.
      </Paragraph>
    </TextBlock>
  );
};
export default OurMandate;
